import React from 'react';
import { cn } from '@rocco/utils/cn';
import { useAppDisplayModeContext } from '@archipro-design/aria';
import type { FilterStates } from '@modules/search/type/filter-state';
import type { ElasticSearchCategories } from '@modules/search/type/api';
import type { FilterStatesKey } from '~/modules/search/type/filter-state';
import type { useSearchFilters } from '@modules/search/hook/use-search-filters';
import {
    LAYOUT_TIMING_FUNCTION,
    LAYOUT_TRANSITION_DURATION,
} from '@modules/category/component/collapsible-page-layout/CollapsiblePageLayout.style';
import { CategoryFilterSection as CategoryFilterSectionDesktop } from './CategoryFilterSection.desktop';
import { CategoryFilterSection as CategoryFilterSectionMobile } from './CategoryFilterSection.mobile';

export interface CategoryFilterSectionProps {
    /** The filter category. */
    category?: ElasticSearchCategories;
    /** The initial filter states. */
    initialStates: FilterStates | null;
    /** The filter drawer open state. */
    filterDrawerOpen: boolean;
    /** The search filters. */
    searchFilters: ReturnType<typeof useSearchFilters>;
    /** The component to render before the filter section. */
    componentBefore?: React.ReactNode;
    /** The component to render after the filter section. */
    componentBarAddon?: React.ReactNode;
}

export const CATEGORY_IGNORE_FILTER_KEYS: FilterStatesKey[] = ['libraryRanges'];

/**
 * The filter section for directory pages which shows the current active filters
 * and sort dropdown.
 */
export const CategoryFilterSection = (props: CategoryFilterSectionProps) => {
    const { desktop } = useAppDisplayModeContext();

    return desktop ? (
        <div
            className={cn(
                'transition-[margin-left] will-change-[margin-left]',
                // margin-left match sidePanelWidth in
                // packages/web/app/modules/category/component/collapsible-page-layout/CollapsiblePageLayout.tsx
                props.filterDrawerOpen && 'ml-[28.75rem]'
            )}
            style={{
                transitionDuration: LAYOUT_TRANSITION_DURATION,
                transitionTimingFunction: LAYOUT_TIMING_FUNCTION,
            }}
        >
            <CategoryFilterSectionDesktop {...props} />
        </div>
    ) : (
        <CategoryFilterSectionMobile {...props} />
    );
};
